import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
import styled from 'styled-components/native';
import { SccTouchableOpacity, } from '@/components/SccTouchableOpacity';
import { font } from '@/constant/font';
function isPressable(props) {
    return props.onPress !== undefined;
}
export function BadgeShell(props) {
    const { backgroundColor, textColor: _textColor, borderColor, borderRadius = 4, paddingHorizontal = 6, children, style, } = props;
    const shellStyle = Object.assign(Object.assign({ backgroundColor,
        borderRadius,
        paddingHorizontal, paddingVertical: 4, flexDirection: 'row', alignItems: 'center', gap: 4, alignSelf: 'flex-start' }, (borderColor ? { borderWidth: 1, borderColor } : {})), style);
    if (isPressable(props)) {
        const { elementName, logParams, disableLogging, trackView, onPress } = props;
        return (_jsx(SccTouchableOpacity, { elementName: elementName, logParams: logParams, disableLogging: disableLogging, trackView: trackView, onPress: onPress, style: shellStyle, children: children }));
    }
    return _jsx(View, { style: shellStyle, children: children });
}
/** 배지 내 텍스트 공통 스타일 — font-size/family의 단일 소스. color는 props로.
 *  line-height는 명시하지 않는다(기존 접근레벨 배지 원본과 동일 — 명시 시 안드로이드에서 높이 달라져 하위호환 깨짐). */
export const BadgeText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 12px;
  color: ${({ textColor }) => textColor};
`;
